import React, { type PropsWithChildren } from 'react';
import type AhaEditorFieldV2Controller from './controllers/AhaEditorFieldV2Controller';

interface ErrorHandlerProps {
  error: Error | null;
  controller: AhaEditorFieldV2Controller;
}

class ErrorHandler extends React.Component<
  PropsWithChildren<ErrorHandlerProps>
> {
  componentDidCatch(error: Error) {
    this.props.controller.actionHandleError(error);
  }

  static getDerivedStateFromError() {
    return {};
  }

  render() {
    const { error, controller } = this.props;
    if (error) {
      controller.actionHandleError(error);
      return null;
    }

    return this.props.children;
  }
}

export default ErrorHandler;
